import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getOrderAge } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries["order-age"];

export const OrderAgeColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => <RedoTableTextCell text={getOrderAge(row)} />,
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
